import style from "./ContinueWatchingStatistics.module.css";
import Icon from "@/ui/icon/Icon";
import CircularProgress from "@/ui/circularProgress/CircularProgress";

function ContinueWatchingStatistics({ courseProgress }) {
	const total_units =
		courseProgress.total_videos + courseProgress.total_quizzes;
	const units_completed =
		courseProgress.videos_completed + courseProgress.quizzes_completed;

	const units_percent = Math.round((100 * units_completed) / total_units);

	return (
		<div className={style.statistics}>
			<CircularProgress
				progress={units_percent / 100}
				color="var(--primary)"
				radius={94}
				stroke={16}
			>
				<div className={style.content}>
					<div className={style.percent}>
						<span>{units_percent}</span>
						<span>%</span>
					</div>
					<div className={style.progress}>
						<span>{units_completed}</span>
						<span>
							<Icon icon="fa-slash-forward" />
						</span>
						<span>{total_units}</span>
					</div>
				</div>
			</CircularProgress>
			<div className={style.progressInfo}>
				<div className={style.individualProgress}>
					<div className={style.percent}>
						<span>
							{courseProgress.total_videos > 0
								? Math.round(
										(100 *
											courseProgress.videos_completed) /
											courseProgress.total_videos
									)
								: 100}
						</span>
						<span>%</span>
					</div>
					<span className={style.label}>Video</span>
				</div>
				<div className={style.individualProgress}>
					<div className={style.percent}>
						<span>
							{courseProgress.total_quizzes > 0
								? Math.round(
										(100 *
											courseProgress.quizzes_completed) /
											courseProgress.total_quizzes
									)
								: 100}
						</span>
						<span>%</span>
					</div>
					<span className={style.label}>testovi</span>
				</div>
			</div>
		</div>
	);
}

export default ContinueWatchingStatistics;
